//用户中心
var user = {
  pageIndex: 2,
  isLoading: false,
  template: '#user-schedule-template',

  //获取数据
  getData: function (pageIndex) {
    msLoader.setLoad();
    var _this = this;
    var url = window.location.href;
    var option = {
      page: pageIndex,
      return: 'json',
    };
    _this.isLoading = true;
    getJson(url, option, function (data) {
      if (data.data.length === 0) {
        //设置加载完成
        msLoader.setEnd();
      } else {
        _this.handleDate(data.data);
        _this.pageIndex += 1;

        _this.isLoading = false;
      }

    });
  },

  //处理数据插入容器
  handleDate: function (data) {
    var _this = this;
    var contentEl = document.querySelector('.content-list-box');//获取容器

    //获取模板
    var itemsHTML = data.map(_this.getItemHTML, _this).join('');

    var proxyElem = document.createElement('div'); //创建代理容器
    proxyElem.innerHTML = itemsHTML;

    var items = proxyElem.querySelectorAll('.list-item'); //获取处理过的html代码

    //添加进容器
    items.forEach(function (item) {
      contentEl.appendChild(item);
    });
    stopRurnLik();
  },

  //获取模板
  getItemHTML: function (data) {
    //判断subModule 获取不同的模板
    var itemTemplateSrc = document.querySelector(this.template).innerHTML;

    //处理数据
    if (data.status) {//会议状态
      switch (data.status) {
        case 1:
          data.showMetLabel = 'met-label-regd';
          break;
        case 2:
          data.showMetLabel = 'met-label-processing';
          break;
        case 3:
          data.showMetLabel = 'met-label-over';
          break;
      }
    }

    //判断直播链接是否存在
    if(data.liveUrl){
      data.showLiveText = 'hide';
      data.showLiveBt = '';
      data.showMetPlay = 'met-playicon';
    }else{
      data.showLiveText = '';
      data.showLiveBt = 'hide';
      data.showMetPlay = '';
    }
    if(data.canDoDesc){ //会议按钮状态文字
      data.liveName = data.canDoDesc;
    }

    if (data.typeUrl) { //处理拼接typeUrl
      data.typeUrl = window.rootUrl + data.typeUrl;
    }

    if (data.author_vip) { //处理vip图标
      data.showVip = '';
    } else {
      data.showVip = 'hide';
    }

    //设置作者链接
    if(data.author_id){
      data.authorUrl = window.rootUrl + '/author/' + data.author_id;
    }


    if (data.type) { //处理文章类型
      if (data.type === 'product' || data.type === 'shop') {
        data.showPriceBox = '';
        data.showAuthor = 'hide';
        data.showLike = 'hide';
      } else {
        data.showPriceBox = 'hide';
        data.showAuthor = '';
        data.showLike = '';
      }
    }

    if(!data.articleUrl){
      data.articleUrl = 'javascript:void(0)';
    }

    //没有图片，替换默认图片
    if (!data.coverurl) {
      if(data.status === '2'){
        data.coverurl = '/static/mobile/images/defaultimg-zbz.jpg';
      }else{
        data.coverurl = '/static/mobile/images/defaultimg.jpg';
      }
    }

    if(data.collect === 0){ //点赞状态
      data.collectType = 'false';
    }else{
      data.collectType = 'true';
    }

    debugger;
    if ((data.type === 'product' || data.type === 'shop') && (data.price || data.sale)) { //是否显示参考价格
      data.showPrice = '';
    } else {
      data.showPrice = 'hide';
    }

    if ((data.type === 'product' || data.type === 'shop') && (!data.price && !data.sale)) { //是否显示联系戴尔
      data.showContact = '';
    } else {
      data.showContact = 'hide';
    }

    if (data.type === 'filelist') { //处理文件类型
      if (data.fileType === 'video') {
        data.showVideoAct = '';
        data.showPlay = 'play';
      } else {
        data.showVideoAct = 'hide';
        data.showPlay = '';
      }

      if (data.fileType === 'file') {
        data.showFiledown = '';
      } else {
        data.showFiledown = 'hide';
      }
    } else {
      data.showPlay = '';
      data.showVideoAct = 'hide';
      data.showFiledown = 'hide';
    }

    if (data.sale) { //价格处理
      data.productPrice = data.sale;
    }else if(data.price){
      data.productPrice = data.price;
    }else{
      data.productPrice = '';
    }


    //渲染模板
    return itemTemplateSrc.replace(/\{\{([\w\-_\.]+)\}\}/gi, function (match, key) {
      var value = data;
      key.split('.').forEach(function (part) {
        value = value[part];
      });
      return value;
    });
  },

  //判断是否已到页面底部
  isBottom: function () {
    var _this = this;
    var scrollT = Math.max(document.body.scrollTop, document.documentElement.scrollTop); //滚动条的垂直偏移
    var scrollH = document.documentElement.scrollHeight || document.body.scrollHeight; //元素的整体高度
    var clientH = document.documentElement.clientHeight || document.body.clientHeight; //元素的可见高度
    if (scrollT >= scrollH - clientH - 100) { //100为修正值
      if (!_this.isLoading) {
        _this.getData(_this.pageIndex);
      }
    }
  },

  //添加滚动监听事件
  addScrollEvent: function () {
    var _this = this;
    window.onscroll = function () {
      _this.isBottom();
    };
  },

  //取消收藏
  cancelCollection: function (id, title) {
    var _this = this;
    msg.dialog('确认要取消收藏吗？', function () {
      var usrInfo = isLogin();
      postJson(window.cateData.api.like, {articleId: id, status: 0, sess: usrInfo.session}, function (data) {
        if (data.result > 0) {
          userRecode({behaviorType: '取消收藏', behaviorResult: '无'});
          loginOut();
          return;
        } else {
          //行为记录
          userRecode({behaviorType: '取消收藏', behaviorResult: title});
        }
      }, true);

      // 删除页面元素
      _this.delMyCollect(id);

      //检查页面item数 小于8个则加载数据
      var itemArr = document.querySelectorAll('.list-item');
      if (itemArr.length < 8) {
        user.isBottom();
      }
    });
  },

  //删除我收藏的内容中的元素
  delMyCollect: function (id) {
    if(document.querySelector('.list-item-' + id)){
      var delEL = document.querySelector('.list-item-' + id);
      delEL.classList.add('hide');
    }
  },

  //恢复删除的内容
  recoveMyCollect: function (id) {
    if(document.querySelector('.list-item-' + id)){
      var delEL = document.querySelector('.list-item-' + id);
      delEL.classList.remove('hide');
    }
  },

  //监听点赞事件
  listenerMessage: function (){
    var _this = this;
    window.addEventListener('message' ,function (e) {
      if(e.data.type === 'like'){
        if(e.data.status === 0){
          _this.delMyCollect(e.data.id);
        }else {
          _this.recoveMyCollect(e.data.id);
        }
      }
    });
  },

  //删除评论
  delCommnet: function (id, uid, content) {
    console.log('删除评论');
    msg.dialog('确认要取消收藏吗？', function () {
      var url = window.cateData.api.delCommnet + '/' + id + '/' + uid;
      getJson(url, '', function (data) {
        console.log(data);
        userRecode({behaviorType: '删除评论', behaviorResult: content});
      });
    });
  },


  init: function () {



    //判断是否登录
    if (!isLogin() && window.cateData.pageModule === 'user') {
      common.gotoLogin();
    }

    if (window.cateData.isHaveData.common) { //判断页面是否有数据
      msLoader.setShow();

      //先执行一次
      this.isBottom();

      //添加监听
      this.addScrollEvent();

      //添加点赞事件监听 如果是用户中心的收藏页面 该事件主要用来监听取消收藏后的删除元素操作
      if(window.cateData.pageModule === 'user' && window.cateData.pageSubModule === 'favorite'){
        this.listenerMessage();
      }
    }

    // 订单类型切换
    $('.order-type-tab .order-type-item').click(function (ele) {
      var typeContentClass = $(this).attr('data-type-class');
      $('.order-type-item').removeClass('active');
      $(this).addClass('active');
      $('.order-type-content').hide();
      $('.'+ typeContentClass).show();
    })
  }
};

if (window.cateData.pageModule === 'user') {
  switch (window.cateData.pageSubModule) {
    case 'favorite':
      user.template = '#user-favorite-template';
      break;
    case 'schedule':
      user.template = '#user-schedule-template';
      break;
    case 'download':
      user.template = '#user-download-template';
      break;
    case 'comment':
      user.template = '#user-comment-template';
      break;
  }
}

if (window.cateData.pageModule === 'author') {
  switch (window.cateData.pageSubModule) {
    case 'comment':
      user.template = '#aurhor-comment-template';
      break;
    case 'article':
      user.template = '#aurhor-article-template';
      break;
  }
}

